module.exports = __webpack_public_path__ + "static/media/LOGO25.da399d34.png";